const dummyCategories = [
  {
    category: 'Self Development',
    line: '/image/Line1.png',
  },
  {
    category: 'Engineering',
    line: '/image/Line2.png',
  },
  {
    category: 'Novel',
    line: '/image/Line3.png',
  },
  {
    category: 'Computer Science',
    line: '/image/Line4.png',
  },
];

export default dummyCategories;
